import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Mail, Phone, MapPin } from 'lucide-react';
import ContactForm from '@/components/common/ContactForm';
import { contact } from '@/data/contact';

const ContactSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const contactInfo = [
    {
      icon: MapPin,
      title: 'Visit Us',
      details: contact.addressLines,
    },
    {
      icon: Phone,
      title: 'Call Us',
      details: [contact.phoneDisplay, `Fax ${contact.faxDisplay}`],
    },
    {
      icon: Mail,
      title: 'Email Us',
      details: [contact.email],
    },
  ];

  return (
    <section ref={ref} className="py-24 relative bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-sm font-semibold text-[#398024] tracking-wider uppercase mb-3">Get in touch</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Contact MAYAN Technology
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Reach us in Umm al-Summaq, Amman, or send a message and we will follow up by email.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="space-y-6">
            {contactInfo.map((info, index) => (
              <motion.div
                key={info.title}
                initial={{ opacity: 0, x: -30 }}
                animate={isInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white border border-gray-200 rounded-xl p-6"
              >
                <div className="w-12 h-12 bg-[#398024] rounded-lg flex items-center justify-center mb-4">
                  <info.icon className="text-white" size={24} />
                </div>
                <h4 className="text-gray-900 font-semibold text-lg mb-2">{info.title}</h4>
                {info.details.map((detail) => (
                  <p key={detail} className="text-gray-600 text-sm">
                    {detail}
                  </p>
                ))}
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="lg:col-span-2 bg-white border border-gray-200 rounded-2xl p-8"
          >
            <ContactForm idPrefix="home-contact" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
